import { Icon, IconProps } from "../icons";
import "./textIcon.style.scss";

interface TextIconProps extends IconProps {
    text: string;
}

export const TextIcon = (props: TextIconProps) => {
    return(
        <div className={`text-icon`}>
            <Icon type={props.type}/>
            <i className="text">
                {props.text}
            </i>
        </div>
    )
}